import { Project } from '../types/Project';
import scriptDetectionImg from '../assets/images/script-detection-planet.png';

import qrcode1 from '../assets/images/qrcode-1.png';
import qrcode2 from '../assets/images/qrcode-2.png';
import qrcode3 from '../assets/images/qrcode-3.png';
import eco2view1 from '../assets/images/eco2view-1.png';
import eco2viewUI1 from '../assets/images/eco2view-ui-1.png';
import eco2viewUI2 from '../assets/images/eco2view-ui-2.png';
import eco2viewUI3 from '../assets/images/eco2view-ui-3.png';
import towa1 from '../assets/images/towa-1.png';
import graphVis1 from '../assets/images/graph-vis-1.png';
import graphVis2 from '../assets/images/graph-vis-2.png';
import satelliteDemo from '../assets/images/satellite-demo.gif';

export const projectsData: Project[] = [
  {
    id: '1',
    title: 'QR Code Enseignants',
    description: "Projet développé pour des chercheurs de l'IUT informatique et présenté sur Twitch. C'est une application complète pour gérer la présence des étudiants via QR Code. J'ai fait le backend en Node.js, une interface prof en React pour scanner rapidement, et un dashboard avec D3.js pour les stats. Tout est conteneurisé avec Docker.",
    technologies: ['Node.js', 'React', 'D3.js', 'Docker', 'PostgreSQL'],
    logoUrl: qrcode1,
    images: [qrcode1, qrcode2, qrcode3],
    isPrivate: true,
    position: [15, 0, 0],
    color: '#7ED321',
    size: 1.4,
    orbitRadius: 15,
    orbitSpeed: 0.008,
    categories: ['Web & Mobile']
  },
  {
    id: '2',
    title: 'Ok Claude',
    description: "Assistant vocal personnel développé pour faciliter les tâches quotidiennes. Il utilise le modèle Whisper d'OpenAI pour une reconnaissance vocale précise (actuellement optimisé pour le français uniquement), permettant de comprendre des commandes variées. L'interface, créée avec PyGame, est volontairement minimaliste pour visualiser simplement l'état de l'écoute. L'architecture est pensée pour être facilement améliorée et ajouter de nouvelles fonctions selon les besoins.",
    technologies: ['Python', 'Vosk', 'Whisper', 'PyGame'],
    logoUrl: scriptDetectionImg,
    images: [scriptDetectionImg],
    githubUrl: 'https://github.com/Yusuaa/Ok-Claude',
    position: [25, 0, 0],
    color: '#FF9900',
    size: 1.8,
    orbitRadius: 25,
    orbitSpeed: 0.006,
    categories: ['Intelligence Artificielle']
  },
  {
    id: '3',
    title: 'Eco2view',
    description: "Projet universitaire (SAE Finale) réalisé en simulation de demande client. Application de visualisation de données environnementales et économiques (CO2, PIB, Population, Agriculture). Développée en C# pour analyser et corréler les impacts du réchauffement climatique.",
    technologies: ['C#', '.NET', 'WPF', 'SQL'],
    logoUrl: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg',
    images: [eco2viewUI1, eco2viewUI2, eco2viewUI3, eco2view1],
    isUniversity: true,
    position: [35, 0, 0],
    color: '#2ECC71',
    size: 1.6,
    orbitRadius: 35,
    orbitSpeed: 0.004,
    categories: ['Data Visualization']
  },
  {
    id: '4',
    title: 'IA Towa (Phase 2)',
    description: "Projet universitaire de développement d'une Intelligence Artificielle pour le jeu de stratégie 'Towa'. Implémentation en Java avec communication réseau (TCP) pour les tournois. Utilisation d'algorithmes de recherche (Minimax/Alpha-Beta) et optimisation des structures de données pour la prise de décision en temps réel.",
    technologies: ['Java', 'TCP/IP', 'Algorithmique', 'NetBeans'],
    logoUrl: towa1,
    images: [towa1],
    isUniversity: true,
    position: [45, 0, 0],
    color: '#E76F00',
    size: 1.7,
    orbitRadius: 45,
    orbitSpeed: 0.003,
    categories: ['Intelligence Artificielle']
  },
  {
    id: '5',
    title: 'Visualisation de Graphe',
    description: "Application de visualisation et de manipulation de graphes développée en Java. Implémentation d'algorithmes de théorie des graphes (BFS, Prim) et interface graphique interactive pour dessiner et analyser des réseaux complexes.",
    technologies: ['Java', 'Algorithmique', 'Graph Theory', 'Swing/AWT'],
    logoUrl: 'https://cdn.simpleicons.org/openjdk',
    images: [graphVis1, graphVis2],
    isUniversity: true,
    position: [55, 0, 0],
    color: '#9B59B6',
    size: 1.6,
    orbitRadius: 55,
    orbitSpeed: 0.002,
    categories: ['Data Visualization']
  },
  {
    id: '6',
    title: 'Predictive Satellite Routing',
    description: "Implémentation du protocole Route Failure Prediction (RFP) pour les constellations de satellites LEO. Extension d'OSPF avec gestion prédictive des liens pour atteindre une perte de paquets quasi-nulle lors des handovers. Simulation réaliste avec ns-3, DCE et la suite de routage Quagga.",
    technologies: ['C++', 'ns-3', 'Docker', 'Quagga', 'OSPF'],
    logoUrl: 'https://cdn.simpleicons.org/cplusplus',
    images: [satelliteDemo],
    githubUrl: 'https://github.com/Yusuaa/Predictive-Satellite-Routing',
    position: [65, 0, 0],
    color: '#00599C',
    size: 1.8,
    orbitRadius: 65,
    orbitSpeed: 0.001,
    categories: ['Systèmes & Réseaux', 'Data Visualization']
  }
];